import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */

/* eslint-disable wf-security/no-location-href */
export var WORKFLOW = '_workflow';
export var VIEW = '_view';
export var cleanPath = function cleanPath(pathname, key) {
  var index = pathname.indexOf(key);
  return pathname.substring(0, index > 0 ? index : undefined);
};
export var getViewUrl = function getViewUrl(location, workflowName, viewName) {
  var viewIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var navigationIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var base = cleanPath(location, '/' + WORKFLOW);
  return [base, WORKFLOW, workflowName, VIEW, viewName].join('/') + '.' + viewIndex + '.' + navigationIndex;
};
export var getViewFromPath = function getViewFromPath(location, workflowName) {
  var subPath = [WORKFLOW, workflowName, VIEW].join('/');
  var extracted = location.substring(location.indexOf(subPath) + subPath.length + 1);
  var trailingSlashPos = extracted.indexOf('/');
  var viewName = trailingSlashPos > 0 ? extracted.substring(0, trailingSlashPos) : extracted;
  var parts = viewName.split('.');
  return {
    viewName: parts[0],
    viewIndex: Number(parts[1] || 0),
    navigationIndex: Number(parts[2] || 0)
  };
};